import { render, staticRenderFns } from "./sellerTop.vue?vue&type=template&id=0ff743a0&"
import script from "./sellerTop.vue?vue&type=script&lang=js&"
export * from "./sellerTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports